module.exports = __webpack_public_path__ + "static/media/convex.8241b1d4.svg";